import {
    tss,
} from 'app/tss'

export default tss.withParams<{fieldsCount: number}>().create(({
    theme,
    fieldsCount,
}) => {
    return {
        rateCard: {
            display: 'grid',
            gridTemplateColumns: `repeat(${fieldsCount}, 1fr)`,
            gap: theme.spacing(2),
            [theme.breakpoints.down('lg')]: {
                gridTemplateColumns: `repeat(${Math.ceil(fieldsCount / 2)}, 1fr)`,
            },
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: 'repeat(1, 1fr)',
            },
        },
    }
})
